import { Component, computed, input } from '@angular/core';

import { CommodityType } from '../../../zentility/_shared/_zen-legacy-common/_models/commodity';

/** Names a bill's commodity with its icon. Renders nothing when the commodity is unknown. */
@Component({
  selector: 'app-commodity-badge',
  standalone: true,
  imports: [],
  template: `
    @if (commodity() === CommodityType.Electricity) {
      <span class="commodity-badge electric" title="Electricity bill">
        <i class="material-symbols-rounded">bolt</i>
        <span>{{ label() }}</span>
      </span>
    }
    @if (commodity() === CommodityType.Gas) {
      <span class="commodity-badge gas" title="Natural gas bill">
        <i class="material-symbols-rounded">local_fire_department</i>
        <span>{{ label() }}</span>
      </span>
    }
    `,
  styleUrl: './commodity-badge.component.scss'
})
export class CommodityBadgeComponent {
    readonly CommodityType = CommodityType;

    readonly commodity = input<CommodityType | undefined>(undefined);

    readonly label = computed(() =>
        this.commodity() === CommodityType.Gas ? 'Natural Gas' : 'Electricity');
}
